module.exports = __webpack_public_path__ + "img/NKCLM-logo.308a47c8.png";